import { styled, Chip as Chip$1 } from '@mui/material';
import { spacing } from '@mui/system';
import { shouldNotForwardProps } from '../../utils.js';

const Chip = styled(Chip$1, {
  shouldForwardProp: shouldNotForwardProps
})(spacing);

export { Chip };
